<template>
  <select
    class="form-control m-input"
    @select="emitChangeEvent"
    @input="emitChangeEvent"
    :value="selectedId"
  >
    <option value="">Selecione</option>
    <option v-for="type in selects" :key="type.id" :value="type.id">{{ type.type }}</option>
  </select>
</template>

<script>
export default {
  name: 'SelectTypes',
  props: {
    selects: {
      type: [Number, String, Array],
    },
    selectedId: [Number, String],
  },
  methods: {
    emitChangeEvent(variable) {
      const value = variable.target.value;
      this.$emit('input', value);
      this.$emit('change', value);
    },
  },
};
</script>
